import React from 'react';
import {
  BackgroundControlWithFiles,
  FindAllFrameCompaniesResponse,
} from '@ansvar-sakerhet/api-client';
import { S } from './FrameCompaniesTable.styles';
import { useTable } from 'react-table';
import { useBackgroundControlsTableData } from './hooks/useBackgroundControlsTableData';

type Props = {
  backgroundControls: BackgroundControlWithFiles[];
  frameCompany: FindAllFrameCompaniesResponse;
};

export const BackgroundControlsTable = ({
  backgroundControls,
  frameCompany,
}: Props) => {
  const data = useBackgroundControlsTableData(backgroundControls, frameCompany);
  const table = useTable(data);

  if (backgroundControls.length === 0) {
    return <S.B1>Inga bakgrundskontroller kunde hittas.</S.B1>;
  }

  return (
    <S.TableContainer>
      <S.AltTable {...table.getTableProps()}>
        <S.AltTHead>
          {table.headerGroups.map((headerGroup) => (
            <S.AltTHeadRow
              {...headerGroup.getHeaderGroupProps()}
              key={headerGroup.getHeaderGroupProps().key}
            >
              {headerGroup.headers.map((column) => {
                return (
                  <S.AltTHeadCell
                    {...column.getHeaderProps()}
                    key={column.getHeaderProps().key}
                  >
                    <S.TableText>{column.render('Header')}</S.TableText>
                  </S.AltTHeadCell>
                );
              })}
            </S.AltTHeadRow>
          ))}
        </S.AltTHead>

        <S.AltTBody {...table.getTableBodyProps()}>
          {table.rows.map((row) => {
            table.prepareRow(row);

            return (
              <S.AltTBodyRow {...row.getRowProps()} key={row.getRowProps().key}>
                {row.cells.map((cell) => {
                  return (
                    <S.AltTBodyCell
                      {...cell.getCellProps()}
                      key={cell.getCellProps().key}
                    >
                      {cell.render('Cell')}
                    </S.AltTBodyCell>
                  );
                })}
              </S.AltTBodyRow>
            );
          })}
        </S.AltTBody>
      </S.AltTable>
    </S.TableContainer>
  );
};
